import React, { useState } from "react";
import { CustomAutoComplete } from "components/CustomComponents/CustomAutoComplete";
import { DownloadForOffline } from "@mui/icons-material";
import { showToast } from "services/utils/Status";
import dayjs from "dayjs";
import * as Mui from "@mui/material";
import { useSelector } from "react-redux";
import { useFetch } from "services/hooks/useFetch";
import { themes } from "services/constants";
import { DepartmentWise } from "./DepartmentWise";
import { ShiftWise } from "./ShiftWise";
const tab_options = ["Department", "Shift"];
const today = dayjs().format("YYYY-MM-DD");

export const Reports = () => {
  const [anchorEl, setAnchorEl] = useState(null);
  const theme = Mui.useTheme();
  const isMobile = Mui.useMediaQuery(theme.breakpoints.down("sm"));
  const { domain, userDetails } = useSelector((state) => state.tokenReducer);
  const [shiftCategoryName, setShiftCategoryName] =
    useState("All ShiftCategory");
  const [shiftCategoryId, setShiftCategoryId] = useState("99999");
  const { result: shiftCategoryList } = useFetch(
    `${domain}user-based-shiftcategory/?user_id=${userDetails?.id}`
  );
  const [departmentName, setDepartmentName] = useState("All Department");
  const [departmentId, setDepartmentId] = useState("99999");
  const [startDate, setStartDate] = useState(today);
  const [leavePage, setLeavePage] = useState(0);
  // const [attendanceDataDetails, setAttendanceDataDetails] = useState([]);
  const [screen, setScreen] = useState("Department");
  const [selectedComponent, setSelectedComponent] = useState("Department");
  const { result: allDepartmentDetails } = useFetch(
    `${domain}get-department/?user_id=${userDetails?.id}`
  );
  const departmentDetails = [
    {
      id: 99999,
      department_name: "All Department",
    },
    ...allDepartmentDetails,
  ];
  const shiftCategoryDetails = [
    {
      id: 99999,
      shift_category_name: "All ShiftCategory",
    },
    ...shiftCategoryList,
  ];
  const {
    result: shiftReports,
    setLoad: reCallShiftApi,
    loading: shiftLoading,
  } = useFetch(
    `${domain}shift-details-report/?user_id=${userDetails?.id}&date=${startDate}&shift_category_id=${shiftCategoryId}`
  );
  const {
    result: departmentReports,
    setLoad: reCallDepartmentApi,
    loading,
  } = useFetch(
    `${domain}department-details-report/?department_id=${departmentId}&user_id=${userDetails?.id}&date=${startDate}`
  );

  const handleDepartmentName = (event, data) => {
    if (data) {
      setDepartmentId(data?.id);
      setDepartmentName(data?.label);
      setTimeout(function () {
        reCallDepartmentApi(true);
      }, 150);
    } else {
      setDepartmentId("");
      setDepartmentName("");
    }
  };

  const renderComponent = () => {
    switch (selectedComponent) {
      case "Department":
        return (
          <DepartmentWise
            departmentReports={departmentReports}
            loading={loading}
            setLeavePage={setLeavePage}
            leavePage={leavePage}
          />
        );
      case "Shift":
        return (
          <ShiftWise
            shiftReports={shiftReports}
            shiftLoading={shiftLoading}
            setLeavePage={setLeavePage}
            leavePage={leavePage}
          />
        );
      // case "WorkUnit":
      //   return (
      //     <WorkUnitWise
      //       shiftReports={shiftReports}
      //       shiftLoading={shiftLoading}
      //       setLeavePage={setLeavePage}
      //       leavePage={leavePage}
      //     />
      //   );
      default:
        break;
    }
  };

  const updateCategoryName = (event, data) => {
    if (data) {
      setShiftCategoryName(data?.label);
      setShiftCategoryId(data?.shift_category_id);
      setTimeout(function () {
        reCallShiftApi(true);
      }, 1000);
    }
  };

  const downloadDepartmentSummarized = () => {
    if (departmentReports.length !== 0) {
      let dataPreparation = [];
      departmentReports?.forEach((element) => {
        let overAllData = {
          department: element?.department_name,
          total_assigned: element?.total_assigned,
          present: element?.present,
          missing: element?.missing,
          leave: element?.leave,
          absent: element?.absent,
          overtime: element?.overtime,
          early_exit: element?.early_exit,
          late_entry: element?.late_entry,
        };
        dataPreparation = [...dataPreparation, overAllData];
      });
      const Department = ["Department Name"];
      const Date = ["Date"];
      Department.push(departmentName);
      Date.push(startDate);
      const items = dataPreparation;
      const TableHead = ["Department Name"];
      TableHead.push("Total Assigned");
      TableHead.push("Present");
      TableHead.push("Missing");
      TableHead.push("Leave");
      TableHead.push("Absent");
      TableHead.push("Over Time");
      TableHead.push("Early Exit");
      TableHead.push("Late Entry");
      const replacer = (key, value) => (value === null ? "" : value);
      const header = Object.keys(items[0]).filter((field) => field !== "type");
      let csv = items.map((row) =>
        header
          .map((fieldName) => JSON.stringify(row[fieldName], replacer))
          .join(",")
      );
      csv.unshift(TableHead.join(","));
      csv.unshift(Date.join(","));
      csv.unshift(Department.join(","));
      csv = csv.join("\r\n");
      const ConvertData = csv;
      const element = document.createElement("a");
      const file = new Blob([ConvertData], {
        type: "text/plain",
      });
      element.href = URL.createObjectURL(file);
      element.download = "SummarizedDepartmentWise.csv";
      document.body.appendChild(element);
      element.click();
    } else {
      showToast("error", "No data available");
    }
  };

  const downloadShiftSummarized = () => {
    if (shiftReports.length !== 0) {
      let dataPreparation = [];
      shiftReports?.forEach((element) => {
        let overAllData = {
          shift_name: element?.shift_name,
          total_assigned: element?.total_assigned,
          present: element?.present,
          missing: element?.missing,
          leave: element?.leave,
          absent: element?.absent,
          overtime: element?.overtime,
          early_exit: element?.early_exit,
          late_entry: element?.late_entry,
        };
        dataPreparation = [...dataPreparation, overAllData];
      });
      const Department = ["Shift Category Name"];
      const Date = ["Date"];
      Department.push(shiftCategoryName);
      Date.push(startDate);
      const items = dataPreparation;
      const TableHead = ["Shift Name"];
      TableHead.push("Total Assigned");
      TableHead.push("Present");
      TableHead.push("Missing");
      TableHead.push("Leave");
      TableHead.push("Absent");
      TableHead.push("Over Time");
      TableHead.push("Early Exit");
      TableHead.push("Late Entry");
      const replacer = (key, value) => (value === null ? "" : value);
      const header = Object.keys(items[0]).filter((field) => field !== "type");
      let csv = items.map((row) =>
        header
          .map((fieldName) => JSON.stringify(row[fieldName], replacer))
          .join(",")
      );
      csv.unshift(TableHead.join(","));
      csv.unshift(Date.join(","));
      csv.unshift(Department.join(","));
      csv = csv.join("\r\n");
      const ConvertData = csv;
      const element = document.createElement("a");
      const file = new Blob([ConvertData], {
        type: "text/plain",
      });
      element.href = URL.createObjectURL(file);
      element.download = "SummarizedShiftWise.csv";
      document.body.appendChild(element);
      element.click();
    } else {
      showToast("error", "No data available");
    }
  };
  const downloadDepartmentDetailed = () => {
    if (departmentReports.length !== 0) {
      let dataPreparation = [];
      departmentReports?.forEach((element) => {
        element.shift_details.forEach((shift) => {
          let overAllData = {
            department_name: element?.department_name,
            shifftname: shift?.shift_name,
            total_assigned: shift?.total_assigned,
            present: shift?.present,
            missing: shift?.missing,
            leave: shift?.leave,
            absent: shift?.absent,
            overtime: shift?.overtime,
            early_exit: shift?.early_exit,
            late_entry: shift?.late_entry,
          };
          dataPreparation = [...dataPreparation, overAllData];
        });
      });
      const Department = ["Department Name"];
      const Date = ["Date"];
      Department.push(departmentName);
      Date.push(startDate);
      const items = dataPreparation;
      const TableHead = ["Department Name"];
      TableHead.push("Shift Name");
      TableHead.push("Total Assigned");
      TableHead.push("Present");
      TableHead.push("Missing");
      TableHead.push("Leave");
      TableHead.push("Absent");
      TableHead.push("Over Time");
      TableHead.push("Early Exit");
      TableHead.push("Late Entry");
      const replacer = (key, value) => (value === null ? "" : value);
      const header = Object.keys(items[0]).filter((field) => field !== "type");
      let csv = items.map((row) =>
        header
          .map((fieldName) => JSON.stringify(row[fieldName], replacer))
          .join(",")
      );
      csv.unshift(TableHead.join(","));
      csv.unshift(Date.join(","));
      if (departmentName === "All Department") {
        csv.unshift(Department.join(","));
      }
      csv = csv.join("\r\n");
      const ConvertData = csv;
      const element = document.createElement("a");
      const file = new Blob([ConvertData], {
        type: "text/plain",
      });
      element.href = URL.createObjectURL(file);
      element.download = "DetailedDepartmentWise.csv";
      document.body.appendChild(element);
      element.click();
    } else {
      showToast("error", "No data available");
    }
  };
  const downloadShiftDetailed = () => {
    if (shiftReports.length !== 0) {
      let dataPreparation = [];
      shiftReports?.forEach((element) => {
        element?.department?.forEach((dep) => {
          let overAllData = {
            department_name: dep?.department_name,
            shift_name: element?.shift_name,
            total_assigned: dep?.total_assigned,
            present: dep?.present,
            missing: dep?.missing,
            leave: dep?.leave,
            absent: dep?.absent,
            overtime: dep?.overtime,
            early_exit: dep?.early_exit,
            late_entry: dep?.late_entry,
          };
          dataPreparation = [...dataPreparation, overAllData];
        });
      });
      const Department = ["Shift Category Name"];
      const Date = ["Date"];
      Department.push(shiftCategoryName);
      Date.push(startDate);
      const items = dataPreparation;
      const TableHead = ["Department Name"];
      TableHead.push("Shift Name");
      TableHead.push("Total Assigned");
      TableHead.push("Present");
      TableHead.push("Missing");
      TableHead.push("Leave");
      TableHead.push("Absent");
      TableHead.push("Over Time");
      TableHead.push("Early Exit");
      TableHead.push("Late Entry");
      const replacer = (key, value) => (value === null ? "" : value);
      const header = Object.keys(items[0]).filter((field) => field !== "type");
      let csv = items.map((row) =>
        header
          .map((fieldName) => JSON.stringify(row[fieldName], replacer))
          .join(",")
      );
      csv.unshift(TableHead.join(","));
      csv.unshift(Date.join(","));
      csv.unshift(Department.join(","));
      csv = csv.join("\r\n");
      const ConvertData = csv;
      const element = document.createElement("a");
      const file = new Blob([ConvertData], {
        type: "text/plain",
      });
      element.href = URL.createObjectURL(file);
      element.download = "DetailedShiftWise.csv";
      document.body.appendChild(element);
      element.click();
    } else {
      showToast("error", "No data available");
    }
  };

  const handleSelection = (event, newValue) => {
    if (newValue) {
      setScreen(newValue);
      setSelectedComponent(newValue);
    }
  };

  return (
    <React.Fragment>
      <Mui.Grid
        container
        spacing={2}
        alignItems="center"
        sx={{ pr: 1, pl: 1, paddingTop: 3, flexWrap: "wrap" }}
      >
        <Mui.Grid item xs={12} md={6} lg={6}>
          <Mui.Box
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              width: "100%",
              maxWidth: { xs: "100%", sm: 320 },
            }}
          >
            {isMobile ? (
              <Mui.FormControl fullWidth>
                <Mui.Select
                  size="small"
                  id="option-select-label"
                  value={screen}
                  fullWidth
                  sx={{
                    fontSize: 16,
                  }}
                  onChange={(e) => handleSelection(null, e.target.value)}
                  renderValue={(selected) => selected}
                >
                  {tab_options.map((item) => (
                    <Mui.MenuItem key={item} value={item}>
                      <Mui.ListItemText primary={item} />
                    </Mui.MenuItem>
                  ))}
                </Mui.Select>
              </Mui.FormControl>
            ) : (
              <Mui.ToggleButtonGroup
                value={screen}
                exclusive
                onChange={handleSelection}
                sx={{
                  display: "flex",
                  width: "100%",
                  backgroundColor: "#e0e0e0",
                  flexWrap: "wrap",
                }}
              >
                {tab_options.map((item) => (
                  <Mui.ToggleButton
                    key={item}
                    value={item}
                    sx={{
                      flex: 1,
                      textTransform: "capitalize",
                      fontSize: 16,
                      fontWeight: 600,
                      border: "none",
                      color:
                        screen === item ? themes.whiteColor : themes.headLine,
                      backgroundColor:
                        screen === item
                          ? themes.primaryIndicator
                          : themes.lightBrown,
                      "&.Mui-selected, &.Mui-selected:hover": {
                        backgroundColor: themes.primaryIndicator,
                        color: themes.whiteColor,
                      },
                      "&:hover, &:focus": {
                        backgroundColor:
                          screen === item
                            ? themes.primaryIndicator
                            : themes.lightBrown,
                        color:
                          screen === item ? themes.whiteColor : themes.headLine,
                      },
                    }}
                  >
                    {item}
                  </Mui.ToggleButton>
                ))}
              </Mui.ToggleButtonGroup>
            )}
          </Mui.Box>
        </Mui.Grid>
        <Mui.Grid item xs={12} sm={6} md={2.5}>
          {selectedComponent === "Shift" ? (
            <CustomAutoComplete
              dataList={shiftCategoryDetails?.map((obj) => ({
                ...obj,
                label: obj?.shift_category_name,
              }))}
              selectedValue={shiftCategoryName}
              updateDataFunction={updateCategoryName}
            />
          ) : (
            <CustomAutoComplete
              dataList={departmentDetails.map((obj) => ({
                ...obj,
                label: obj.department_name,
              }))}
              selectedValue={departmentName}
              updateDataFunction={handleDepartmentName}
              placeHolder="Please select the department name"
            />
          )}
        </Mui.Grid>

        <Mui.Grid item xs={12} sm={6} md={2.5}>
          <Mui.TextField
            size="small"
            type="date"
            id="from_date"
            value={startDate}
            onChange={(event) => {
              setStartDate(event.target.value);
              if (screen === "Department") {
                reCallDepartmentApi(true);
              } else {
                reCallShiftApi(true);
              }
            }}
            fullWidth
          />
        </Mui.Grid>

        <Mui.Grid
          item
          xs={12}
          sm={6}
          md={1}
          sx={{
            display: "flex",
            justifyContent: {
              xs: "flex-end",
              sm: "flex-end",
              md: "flex-start",
              lg: "flex-start",
            },
            alignItems: "center",
            padding: 0,
            ml: { sm: "auto", md: 0 },
            mr: { sm: 0, md: "auto" },
          }}
        >
          <Mui.IconButton
            onClick={(e) => setAnchorEl(e.currentTarget)}
            sx={{
              backgroundColor: themes.primary,
              "&:hover": { backgroundColor: themes.primary },
            }}
          >
            <DownloadForOffline
              fontSize="large"
              sx={{ color: themes.blueColor }}
            />
          </Mui.IconButton>

          <Mui.Menu
            anchorEl={anchorEl}
            open={Boolean(anchorEl)}
            onClose={() => setAnchorEl(null)}
            elevation={1}
            transformOrigin={{ horizontal: "right", vertical: "top" }}
            anchorOrigin={{ horizontal: "right", vertical: "bottom" }}
          >
            <Mui.MenuItem
              sx={{ width: "100%" }}
              onClick={() => {
                setAnchorEl(null);
                screen === "Department"
                  ? downloadDepartmentSummarized()
                  : downloadShiftSummarized();
              }}
            >
              Summarized Reports
            </Mui.MenuItem>
            <Mui.MenuItem
              sx={{ width: "100%" }}
              onClick={() => {
                setAnchorEl(null);
                screen === "Department"
                  ? downloadDepartmentDetailed()
                  : downloadShiftDetailed();
              }}
            >
              Detailed Reports
            </Mui.MenuItem>
          </Mui.Menu>
        </Mui.Grid>
      </Mui.Grid>
      {renderComponent()}
    </React.Fragment>
  );
};
